import type { U3204MessageSource } from '../U3204Service';

/** True si le tableau sources doit afficher le bloc Sources (BL-0200). */
export function u3204HasMessageSources(
  sources: U3204MessageSource[] | null | undefined,
): sources is U3204MessageSource[] {
  return Array.isArray(sources) && sources.length > 0;
}
